import { node, string, bool } from "prop-types";
import React, { useState, forwardRef, useEffect } from "react";
import { twMerge } from "tailwind-merge";

import VisibilityIcon from "./Icons/Visibility";
import VisibilityOffIcon from "./Icons/VisibilityOff";

const TextField = forwardRef((props, ref) => {
  const {
    className,
    disabled = false,
    errorHelperMessage,
    fullWidth = false,
    label,
    maxLength,
    name,
    placeholder,
    prefix,
    required,
    suffix,
    type = "text",
    ...restProps
  } = props;

  const [isVisible, setVisible] = useState(false);
  const isPassword = type === "password";

  useEffect(() => {
    const inputElement = document.querySelector(`[name=${name}]`);

    if (!inputElement) {
      return;
    }

    inputElement.addEventListener("input", () => {
      inputElement.setCustomValidity("");

      if (!inputElement.validity.valid && errorHelperMessage) {
        inputElement.setCustomValidity(errorHelperMessage);
      }
    });
  }, []);

  return (
    <label
      aria-label={!label || label === "" ? placeholder : label}
      className={twMerge(
        "flex flex-col gap-2 mt-8 cursor-text",
        fullWidth && "w-full",
        className
      )}
    >
      {label}
      {required && "*"}
      <div
        className={twMerge(
          "flex items-center border-2 border-greyLight rounded-sm text-base tracking-wide",
          disabled ? "bg-greyLight" : "bg-white"
        )}
      >
        {prefix && <div className="px-2">{prefix}</div>}
        <input
          className="border-0 text-sm font-citroen outline-0 flex-1-1-0 p-2 disabled:bg-greyLight"
          type={isPassword && isVisible ? "text" : type}
          required={required}
          ref={ref}
          disabled={disabled}
          maxLength={maxLength}
          name={name}
          placeholder={placeholder}
          {...restProps}
        />
        {suffix && <div className="px-2">{suffix}</div>}
        {isPassword && (
          <button
            className="p-1"
            onClick={() => setVisible(!isVisible)}
            type="button"
          >
            {isVisible ? (
              <VisibilityIcon size="md" />
            ) : (
              <VisibilityOffIcon size="md" />
            )}
          </button>
        )}
      </div>
    </label>
  );
});

TextField.displayName = "TextField";

TextField.propTypes = {
  className: string,
  disabled: bool,
  errorHelperMessage: string,
  fullWidth: bool,
  label: node,
  maxLength: string,
  multiline: bool,
  name: string,
  placeholder: string,
  prefix: node,
  required: bool,
  suffix: node,
  type: string,
};

export default TextField;
